export type SectionIds = {
	about: string;
	portfolio: string;
	news: string;
	partners: string;
	opportunities: string;
	career: string;
	contact: string;
};

export const sectionIds: SectionIds = {
	about: "about",
	portfolio: "portfolio",
	news: "news",
	partners: "partners",
	opportunities: "opportunities",
	career: "career",
	contact: "contact",
};

export type JobPosition = {
	id: string;
	title: string;
	titleEn: string;
	location: string;
	type: string;
	description: string;
	descriptionEn: string;
	tasks: string[];
	tasksEn: string[];
	qualifications: string[];
	qualificationsEn: string[];
	offers: string[];
	offersEn: string[];
};

export const openPositions: JobPosition[] = [
	{
		id: "receptionist",
		title: "Рецепционер/ка",
		titleEn: "Receptionist",
		location: 'Хотелите во состав на "Македонијатурист" АД - Скопје',
		type: "Полно работно време (работа во смени)",
		description:
			'"Македонијатурист" АД - Скопје бара љубезен, комуникативен и професионален Рецепционер кој ќе биде прва контакт точка со гостите, ќе обезбедува висок квалитет на услуга и ќе придонесува за позитивно искуство на хотелските гости.',
		descriptionEn:
			'"Makedonijaturist" AD - Skopje is looking for a friendly, communicative and professional Receptionist who will be the first point of contact with guests, providing high-quality service and contributing to a positive hotel guest experience.',
		tasks: [
			"Пречек и услужување на гости при пристигнување и заминување",
			"Извршување check-in и check-out процедури",
			"Давање информации за хотелските услуги и туристичките содржини",
			"Прием и обработка на резервации (лично, телефонски и електронски)",
			"Работа со хотелски информативен систем",
			"Наплата и издавање фискални сметки",
			"Решавање на барања и поплаки од гости на професионален начин",
			"Соработка со другите хотелски служби",
			"Почитување на хотелските стандарди и процедури",
		],
		tasksEn: [
			"Welcoming and serving guests at arrival and departure",
			"Performing check-in and check-out procedures",
			"Providing information about hotel services and tourist attractions",
			"Handling reservations (in person, by phone and electronically)",
			"Operating the hotel information system",
			"Issuing invoices and fiscal receipts",
			"Resolving guest requests and complaints professionally",
			"Collaborating with other hotel departments",
			"Adhering to hotel standards and procedures",
		],
		qualifications: [
			"Завршено средно или високо образование (туризам/угостителство - предност)",
			"Претходно работно искуство, но добредојдени се и кандидати без работно искуство",
			"Одлично познавање на македонски и англиски јазик (друг странски јазик - предност)",
			"Основно компјутерско познавање (MS Office, хотелски софтвер)",
			"Комуникативност, љубезност и професионален изглед",
			"Способност за работа во смени и под притисок",
		],
		qualificationsEn: [
			"Secondary or higher education (tourism/hospitality preferred)",
			"Previous work experience, but candidates without experience are also welcome",
			"Excellent knowledge of Macedonian and English (additional foreign language is an advantage)",
			"Basic computer skills (MS Office, hotel software)",
			"Communication skills, friendliness and professional appearance",
			"Ability to work in shifts and under pressure",
		],
		offers: [
			"Редовна и стабилна плата",
			"Регрес за годишен одмор (К-15)",
			"Топол оброк",
			"Долгорочно вработување по пробен период",
			"Работа во најголемиот хотелски систем во државата",
			"Пријатна и динамична работна средина",
		],
		offersEn: [
			"Regular and stable salary",
			"Annual leave allowance (K-15)",
			"Warm meal",
			"Long-term employment after probation period",
			"Work in the largest hotel system in the country",
			"Pleasant and dynamic working environment",
		],
	},
	{
		id: "waiter",
		title: "Келнери/Келнерки",
		titleEn: "Waiters/Waitresses",
		location: "Македонијатурист АД - Скопје",
		type: "Полно работно време",
		description:
			"Работа во ресторанскиот и услужниот сектор на хотелите во состав на Македонијатурист АД - Скопје.",
		descriptionEn:
			"Work in the restaurant and service sector of hotels within Makedonijaturist AD - Skopje.",
		tasks: [
			"Пречек и услужување на гости",
			"Примање и реализирање на нарачки",
			"Одржување хигиена и уредност на работното место",
			"Учество во организација и реализација на настани",
			"Грижа за позитивно искуство на гостите",
		],
		tasksEn: [
			"Welcoming and serving guests",
			"Taking and fulfilling orders",
			"Maintaining cleanliness and tidiness in the workplace",
			"Participating in the organisation and execution of events",
			"Ensuring a positive guest experience",
		],
		qualifications: [
			"Средно образование",
			"Претходно работно искуство ќе се смета за предност",
			"Одговорност, дисциплина и точност",
			"Способност за самостојна и тимска работа",
			"Комуникативност и професионален однос",
			"Подготвеност за работа во смена",
			"Познавање на англиски јазик",
		],
		qualificationsEn: [
			"Secondary education",
			"Previous work experience will be considered an advantage",
			"Responsibility, discipline and punctuality",
			"Ability to work independently and in a team",
			"Communication skills and professional conduct",
			"Willingness to work in shifts",
			"Knowledge of English",
		],
		offers: [
			"Редовна и стабилна плата",
			"Регрес за годишен одмор (К-15)",
			"Топол оброк",
			"Долгорочно вработување по пробен период",
			"Работа во најголемиот хотелски систем во државата",
			"Пријатна и динамична работна средина",
		],
		offersEn: [
			"Regular and stable salary",
			"Annual leave allowance (K-15)",
			"Warm meal",
			"Long-term employment after probation period",
			"Work in the largest hotel system in the country",
			"Pleasant and dynamic working environment",
		],
	},
	{
		id: "assistant-waiter",
		title: "Помошници Келнери/Келнерки",
		titleEn: "Assistant Waiters/Waitresses",
		location: "Македонијатурист АД - Скопје",
		type: "Полно работно време",
		description:
			"Работа во услужниот сектор, поддршка на келнерскиот персонал и одржување на стандардите за хигиена и послужување.",
		descriptionEn:
			"Work in the service sector, supporting the waitstaff and maintaining hygiene and service standards.",
		tasks: [
			"Помош при послужување на гости",
			"Подготовка и поставување на маси",
			"Одржување на хигиена во работниот простор",
			"Помош на келнерите во текот на работниот процес",
		],
		tasksEn: [
			"Assisting with guest service",
			"Preparing and setting tables",
			"Maintaining cleanliness in the work area",
			"Supporting the waitstaff throughout the service process",
		],
		qualifications: [
			"Љубезност и комуникативност",
			"Одговорност и тимска работа",
			"Желба за работа во угостителство",
			"Претходно искуство ќе се смета за предност",
		],
		qualificationsEn: [
			"Friendliness and communication skills",
			"Responsibility and teamwork",
			"Desire to work in hospitality",
			"Previous experience will be considered an advantage",
		],
		offers: [
			"Редовна и стабилна плата",
			"Регрес за годишен одмор (К-15)",
			"Топол оброк",
			"Долгорочно вработување по пробен период",
			"Работа во најголемиот хотелски систем во државата",
			"Пријатна и динамична работна средина",
		],
		offersEn: [
			"Regular and stable salary",
			"Annual leave allowance (K-15)",
			"Warm meal",
			"Long-term employment after probation period",
			"Work in the largest hotel system in the country",
			"Pleasant and dynamic working environment",
		],
	},
];

export type Hotel = {
	name: string;
	nameEn: string;
	category: string;
	categoryEn: string;
	address: string;
	latitude: number;
	longitude: number;
	description: string;
	descriptionEn: string;
	image?: string;
};

export const hotels: Hotel[] = [
	{
		name: "Holiday Inn Скопје",
		nameEn: "Holiday Inn Skopje",
		category: "5★ / IHG бренд",
		categoryEn: "5★ / IHG Brand",
		address: "Kej 13-ti Noemvri 2, Centar",
		latitude: 41.9945864,
		longitude: 21.4360328,
		description:
			"Меѓународен хотел со силен фокус на бизнис патници и MICE, со искуство усогласено со Holiday Inn стандардите.",
		descriptionEn:
			"International hotel with a strong focus on business travellers and MICE, with an experience aligned with Holiday Inn standards.",
		image: "/HolidayInn/HolidayInn.jpg",
	},
	{
		name: "Хотел Карпош",
		nameEn: "Hotel Karposh",
		category: "Модерен градски престој",
		categoryEn: "Modern City Stay",
		address: "Shekspirova, Karpoš 2",
		latitude: 42.0019574,
		longitude: 21.407539,
		description:
			"Модерен градски хотел за бизнис гости и подолги престои, функционален, чист и удобен.",
		descriptionEn:
			"Modern urban hotel for business guests and longer stays, functional, clean and comfortable.",
		image: "/HotelKarposh/HotelKarpos_FrontView.png",
	},
	{
		name: "Хотел Турист",
		nameEn: "Hotel Turist",
		category: "Централен градски хотел",
		categoryEn: "Central City Hotel",
		address: "Gjuro Strugar 11, Centar",
		latitude: 41.9936345600724,
		longitude: 21.42985186458187,
		description:
			"Градски хотел во центарот на Скопје, практичен избор за гости кои сакаат да бидат 'на чекор' од се.",
		descriptionEn:
			"City hotel in the centre of Skopje, a practical choice for guests who want to be a step away from everything.",
		image: "/HotelTurist/Turist_S.png",
	},
	{
		name: "Хотел Bellevue",
		nameEn: "Hotel Bellevue",
		category: "Одмор & природа",
		categoryEn: "Leisure & Nature",
		address: "Motorway 2 (Miladinovci – Skopje)",
		latitude: 41.9968121,
		longitude: 21.5520138,
		description:
			"Мирен престој во зеленина надвор од гужвата, простор, воздух и природа за семејства и групи.",
		descriptionEn:
			"Peaceful stay in greenery away from the bustle, with space, fresh air and nature for families and groups.",
		image: "/HotelBellevue/IMG_9845.jpg",
	},
	{
		name: "Хотел Водно",
		nameEn: "Hotel Vodno",
		category: "Одмор & природа",
		categoryEn: "Leisure & Nature",
		address: "ul. Kozle, Vodno",
		latitude: 41.9785,
		longitude: 21.4125,
		description:
			"Тивок престој во подножјето на Водно, идеален за гости кои бараат мир, зеленило и блискост до природата.",
		descriptionEn:
			"Quiet retreat at the foot of Vodno, ideal for guests seeking peace, greenery and closeness to nature.",
	},
];

export const partnerBenefits = [
	"Централни локации",
	"Конференциски капацитети",
	"Координација преку една контакт точка",
	"Флексибилни корпоративни услови",
];

export type NewsArticle = {
	id: string;
	title: string;
	titleEn?: string;
	excerpt: string;
	excerptEn?: string;
	date: string;
	dateEn?: string;
	category: string;
	categoryEn?: string;
	image?: string;
	body?: string[];
	bodyEn?: string[];
};

export const newsArticles: NewsArticle[] = [
	{
		id: "1",
		title: "Твојата кариера во срцето на гостопримството",
		titleEn: "Your Career at the Heart of Hospitality",
		excerpt:
			"Повеќе од 63 години, Македонијатурист претставува симбол за гостопримство, изграден врз цврсти вредности и длабока почит кон традицијата. Ве покануваме да ни се придружите на ова патување.",
		excerptEn:
			"For over 63 years, Makedonijaturist has stood as a symbol of hospitality, built on solid values and deep respect for tradition. We invite you to join us on this journey.",
		date: "1 Март 2026",
		dateEn: "1 March 2026",
		category: "Кариера",
		categoryEn: "Career",
		body: [
			"Повеќе од 63 години, Македонијатурист претставува симбол за гостопримство, изграден врз цврсти вредности, посветеност и длабока почит кон традицијата. Она што започна како визија прерасна во доверливо маке кое пречекува генерации гости со топлина и грижа.",
			"Денес, нашето портфолио вклучува четири хотели и колекција на ресторани, некои сместени во самите хотели, додека други претставуваат препознатливи дестинации сами по себе. Со уште два хотела кои во моментов се во фаза на реновирање, продолжуваме да растеме и да се развиваме, означувајќи едно ново, возбудливо поглавје на трансформација.",
			"Веруваме дека иднината на угостителството се потпира на почитувањето на минатото, но и на прифаќањето на промените. Токму затоа, внесуваме нова енергија во традицијата, спојувајќи децениско искуство со свежи перспективи, иновации и напреден начин на размислување.",
			"Во сржта на сè што работиме се нашите луѓе. Нашата филозофија како работодавач е фокусирана на создавање работна средина во која секој поединец се чувствува охрабрен, почитуван и инспириран да успее. Посветени сме на негување на талентите, поттикнување на нивниот професионален развој и отворање нови можности низ нашето портфолио кое постојано се проширува.",
			"Да се работи со нас значи да се биде дел од нешто поголемо: динамична групација која постојано се развива, каде што вашите идеи се важни, вашиот раст е поддржан, а вашиот труд е препознаен и вреднуван. Без разлика дали ќе бидете дел од некој од нашите веќе етаблирани хотели или од новите објекти кои наскоро ќе бидат отворени, секој член на тимот има клучна улога во обликувањето на нашата иднина.",
			"Доколку имате страст кон угостителството и сте мотивирани да се развивате во компанија која го цени своето наследство, но пред сè ги цени своите луѓе, ве покануваме да ни се придружите на ова патување.",
		],
		bodyEn: [
			"For over 63 years, Makedonijaturist has stood as a symbol of hospitality, built on solid values, dedication and deep respect for tradition. What began as a vision grew into a trusted name welcoming generations of guests with warmth and care.",
			"Today, our portfolio includes four hotels and a collection of restaurants, some situated within the hotels themselves, while others stand as distinctive destinations in their own right. With two more hotels currently undergoing renovation, we continue to grow and evolve, marking an exciting new chapter of transformation.",
			"We believe that the future of hospitality rests on honouring the past while embracing change. That is why we are bringing fresh energy into tradition, combining decades of experience with new perspectives, innovation and forward thinking.",
			"At the heart of everything we do are our people. Our philosophy as an employer is centred on creating a work environment where every individual feels encouraged, valued and inspired to succeed. We are committed to nurturing talent, supporting professional growth and opening new opportunities across our ever-expanding portfolio.",
			"Working with us means being part of something greater: a dynamic group that is constantly evolving, where your ideas matter, your growth is supported and your work is recognised and valued. Whether you join one of our established hotels or one of the new properties opening soon, every team member plays a key role in shaping our future.",
			"If you are passionate about hospitality and motivated to grow within a company that values its heritage, but above all values its people, we invite you to join us on this journey.",
		],
	},
	{
		id: "2",
		title:
			"Нова дигитална ера: Лансирање на нашиот нов веб-сајт и почеток на хотелиерската револуција!",
		titleEn:
			"A New Digital Era: Launching Our New Website and the Start of the Hotel Revolution!",
		excerpt:
			"Со огромно задоволство ви го претставуваме нашиот целосно нов, модерен веб-сајт. Тој е дигиталниот одраз на вистинската хотелиерска револуција која допрва ќе го менува лицето на гостопримството кај нас.",
		excerptEn:
			"We are delighted to present our brand new, modern website. It is the digital reflection of a true hotel revolution that will continue to transform the face of hospitality here.",
		date: "6 Април 2026",
		dateEn: "6 April 2026",
		category: "Вести",
		categoryEn: "News",
		body: [
			"Добредојдовте во новото поглавје на Македонијатурист АД! Со огромно задоволство ви го претставуваме нашиот целосно нов, модерен веб-сајт.",
			"Овој чекор напред претставува многу повеќе од само освежен онлајн изглед. Тој е дигиталниот одраз на вистинската хотелиерска револуција што ја започнавме и која допрва ќе го менува лицето на гостопримството кај нас.",
			"Во изминатиот период, нашиот тим неуморно работеше на креирање на една нова, посилна и поповрзана приказна за сите наши капацитети. Преку новиот сајт, сакавме да ги обединиме глобалните стандарди со нашето препознатливо локално гостопримство. Сега, со само неколку клика, можете да го пронајдете идеалното место за вашиот следен престој: без разлика дали го барате премиум бизнис искуството во Holiday Inn Скопје, сакате да сте во пулсот на градот преку Хотел Турист, ви треба функционална удобност во Хотел Карпош, или пак копнеете по простор, природа и мирен одмор во Хотел Bellevue.",
			"Но, вистината е дека овој веб-сајт е само почеток. Тој е буквално само врвот на ледениот брег од промените што ги планираме за 2026 година!",
			"Оваа година сме целосно посветени на иновации, подобрување на корисничкото искуство и подигнување на нашите услуги на едно сосема ново, светско ниво. Подготвуваме низа изненадувања: од големи реновирања и модернизација на нашите лобија и конференциски сали, преку ексклузивни корпоративни понуди, па сè до нови возбудливи партнерства со врвни локални производители за да ви ги понудиме најавтентичните вкусови.",
			"Сакаме да го редефинираме значењето на квалитетен престој во Скопје и да поставиме нови стандарди во индустријата. Традицијата која ја градиме од 1963 година останува нашата најсилна основа, но сега ја надградуваме со модерен дизајн, брза дигитална комуникација и врвна услуга.",
			"Ве покануваме да го истражите нашиот нов веб-сајт, да се запознаете со нашите понуди и да нè следите на нашите социјални мрежи, бидејќи возбудливи новости ќе споделуваме многу често.",
			"Бидете дел од нашата хотелиерска револуција. Најдоброто допрва доаѓа!",
		],
		bodyEn: [
			"Welcome to a new chapter of Makedonijaturist AD! We are delighted to present our brand new, modern website.",
			"This step forward represents much more than a refreshed online presence. It is the digital reflection of a true hotel revolution we have set in motion, one that will continue to transform the face of hospitality here.",
			"Over the past period, our team worked tirelessly to craft a new, stronger and more connected story for all our properties. Through the new website, we wanted to bring together global standards and our signature local hospitality. Now, with just a few clicks, you can find the perfect place for your next stay: whether you are looking for the premium business experience at Holiday Inn Skopje, want to be at the pulse of the city with Hotel Turist, need functional comfort at Hotel Karposh, or long for space, nature and a peaceful retreat at Hotel Bellevue.",
			"But the truth is, this website is just the beginning. It is quite literally the tip of the iceberg of the changes we have planned for 2026!",
			"This year we are fully committed to innovation, improving the guest experience and elevating our services to a completely new, world-class level. We are preparing a series of surprises: from major renovations and modernisation of our lobbies and conference halls, to exclusive corporate offers, and new exciting partnerships with top local producers to bring you the most authentic flavours.",
			"We want to redefine what a quality stay in Skopje means and set new standards in the industry. The tradition we have been building since 1963 remains our strongest foundation, and we are now enhancing it with modern design, fast digital communication and exceptional service.",
			"We invite you to explore our new website, discover our offers and follow us on social media, as we will be sharing exciting news very often.",
			"Be part of our hotel revolution. The best is yet to come!",
		],
	},
];
